'use strict';
define(['./util', './analytics', './constantvalues', './../data/config/app'], function (Utils, analytics, Constantvalues, Config) {

    var slideliElements = 0,
        positionValue,
        position;
    var setDirection, activebubbleIndex, direction,
        timeoutForRemoveProduct = {}, removedItemCount = 0;
    var CAROUSEL_ID;
    var carouselInteractionId;
    var totalNumberofSlides;
    var productTcode;
    var productcarouselinteractionId;
    var scrollclicked = 0, leftswiped = 0;
    var carouselseenCount = 0;
    var xDown = null;
    var yDown = null;
    var leftSwipeCount = 0;
    var rightSwipeCount = 0;
    function Carouseltemplate(el) {
        this.carousel = el;
    }

    Carouseltemplate.prototype = {
        init: function () {
            var recentlyviewedItemArray = this.carousel;
            this.wrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
            this.sliderpreviousbtn = document.querySelector('.navfooter-desktopcarousel__previousbtn');
            this.slidernextbtn = document.querySelector('.navfooter-desktopcarousel__nextbtn');
            this.slideIndex = 0;
            this.pageTypeElement = document.getElementById('pageType');
            if (this.pageTypeElement) {
                CAROUSEL_ID = '#intid=carousel_FUNH_AT_RECENT_END_' + this.pageTypeElement.innerText;
                carouselInteractionId = 'FUNH_AT_RECENT_END_' + this.pageTypeElement.innerText;

            }
            var template = `<li class="navfooter-desktopcarousel__slide-product">
            <div class="navfooter-desktopcarousel__slide-productitem">
            <div class="navfooter-desktopcarousel__slideproddetails">
                <div class="navfooter-desktopcarousel__imagetiles">
                    <a > <div class="navfooter-desktopcarousel__imagediv"><span><img
                            src="" /></span>
                </div>
                <div class="navfooter-desktopcarousel__price"> 
                <span class="navfooter-desktopcarousel-pricedetails"></span>
                <span class="navfooter-desktopcarousel-waspricediv"></span>
                </div>
                </a></div>
                <a  href="javascript:void(0)"class="navfooter-desktopcarousel__remove" aria-label="remove">Remove</a>
                </div>
                <div class="navfooter-desktopcarousel__undowrapper"><span class="navfooter-desktopcarousel__undolabel">Item Removed</span>
                <a href="javascript:void(0)" class="navfooter-desktopcarousel__undo">Undo</a></div>
            </div>
        </li>`;
            var sliderButtontemplate = `<button class="navfooter-desktopcarousel__page-button" tabindex="-1">
            <span class="navfooter-desktopcarousel__page">
                <span class="navfooter-desktopcarousel__slidenumber"></span>
            </span>`;

            var brandNametemplate = `<div class="navfooter-desktopcarousel__brand">
                <span></span>
            </div>`;

            var productTitletemplate = `<div class="navfooter-desktopcarousel__title">
                <span></span>
            </div>`;

            for (var i = 0; i < recentlyviewedItemArray.length; i++) {
                if (recentlyviewedItemArray[i].id !== '') {
                    slideliElements++;
                    this.wrapper.innerHTML += template;
                    this.productwrapperli = document.querySelectorAll('.navfooter-desktopcarousel__slide-product-wrapper li');
                    this.productImageTag = this.wrapper.getElementsByTagName('img');
                    this.productImagehrefTag = this.productwrapperli[i].querySelector('.navfooter-desktopcarousel__imagetiles a');
                    this.productpriceDetails = this.productwrapperli[i].querySelector('.navfooter-desktopcarousel__price .navfooter-desktopcarousel-pricedetails');
                    this.productwaspriceDetails = this.productwrapperli[i].querySelector('.navfooter-desktopcarousel__price .navfooter-desktopcarousel-waspricediv');

                    this.productwrapperli[i].setAttribute('id', recentlyviewedItemArray[i].id);
                    this.productwrapperli[i].setAttribute('TCode', recentlyviewedItemArray[i].TCode);
                    this.productImageTag[i].setAttribute('src', recentlyviewedItemArray[i].imageURL);
                    this.productImageTag[i].setAttribute('data-src', recentlyviewedItemArray[i].imageURL);
                    if (typeof CAROUSEL_ID !== 'undefined' && CAROUSEL_ID !== null && CAROUSEL_ID !== 'undefined') {
                        this.imageurlwithanalytics = recentlyviewedItemArray[i].productURL + CAROUSEL_ID + '_' + recentlyviewedItemArray.length + '_' + (i + 1);
                        this.productImagehrefTag.setAttribute('href', this.imageurlwithanalytics);
                        this.productwrapperli[i].setAttribute('carouselInteractionId', carouselInteractionId + '_' + (i + 1));
                    }
                    else {
                        this.productImagehrefTag.setAttribute('href', recentlyviewedItemArray[i].productURL);
                    }
                    if (recentlyviewedItemArray[i].SaleFlag === 'Y') {
                        this.productpriceDetails.innerHTML = this.printPriceRange(recentlyviewedItemArray[i].priceRange);
                        Utils.addClass(this.productpriceDetails, 'saleprice');
                        this.productImagehrefTag.setAttribute('aria-label', recentlyviewedItemArray[i].name + ' ' + this.printPriceRange(recentlyviewedItemArray[i].priceRange));
                    }
                    else if (recentlyviewedItemArray[i].PromotionFlag === 'Y') {
                        this.productpriceDetails.innerHTML = this.printPriceRange(recentlyviewedItemArray[i].PromotionalPriceRange);
                        Utils.addClass(this.productpriceDetails, 'promotionalprice');
                        this.productwaspriceDetails.innerHTML = this.printwasprice(recentlyviewedItemArray[i].priceRange);
                        this.productImagehrefTag.setAttribute('aria-label', recentlyviewedItemArray[i].name + ' ' + 'Previous price ' + this.printwasprice(recentlyviewedItemArray[i].priceRange) + ' Current Price ' + this.printPriceRange(recentlyviewedItemArray[i].PromotionalPriceRange));
                    }
                    else {
                        this.productpriceDetails.innerHTML = this.printPriceRange(recentlyviewedItemArray[i].priceRange);
                        Utils.addClass(this.productpriceDetails, 'saleprice');
                        this.productImagehrefTag.setAttribute('aria-label', recentlyviewedItemArray[i].name + ' ' + this.printPriceRange(recentlyviewedItemArray[i].priceRange));
                    }

                    if (recentlyviewedItemArray[i].Brand) {
                        this.productImagehrefTag.innerHTML += brandNametemplate;
                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__brand').setAttribute('aria-label', recentlyviewedItemArray[i].Brand);
                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__brand span').innerText = recentlyviewedItemArray[i].Brand.toUpperCase();
                    }

                    if (recentlyviewedItemArray[i].name) {
                        this.productImagehrefTag.innerHTML += productTitletemplate;
                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__title').setAttribute('aria-label', recentlyviewedItemArray[i].name);
                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__title span').innerText = recentlyviewedItemArray[i].name;
                    }

                    if (recentlyviewedItemArray[i].rating) {
                        this.ratingPercentage = (parseFloat(recentlyviewedItemArray[i].rating)/5)*100;

                        var productRatingtemplate = `<div class="navfooter-desktopcarousel__rating">
                            <p class="star-rating">
                                <span class="star-rating__base">
                                    <svg aria-hidden="true" width="89" height="12" viewBox="0 0 61 11" xmlns="http://www.w3.org/2000/svg"
                                        title="Star Rating">
                                        <g>
                                            <path
                                                d="M2.101 11l.655-3.987L0 4.193l3.79-.584L5.512 0l1.723 3.644 3.79.584-2.757 2.819L8.923 11 5.512 9.11zM14.595 11l.655-3.987-2.756-2.82 3.79-.584L18.006 0l1.723 3.644 3.79.584-2.757 2.819.655 3.953-3.411-1.89zM27.09 11l.654-3.987-2.756-2.82 3.79-.584L30.5 0l1.723 3.644 3.789.584-2.756 2.819.655 3.953L30.5 9.11zM39.583 11l.655-3.987-2.756-2.82 3.79-.584L42.993 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89zM52.077 11l.655-3.987-2.756-2.82 3.79-.584L55.487 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89z">
                                            </path>
                                        </g>
                                    </svg></span>
                                    <span class="star-rating__filled"  style="width: calc(`+this.ratingPercentage+`%);">
                                    <svg
                                        aria-hidden="true" width="89" height="12" viewBox="0 0 61 11" xmlns="http://www.w3.org/2000/svg"
                                        title="Star Rating">
                                        <g>
                                            <path
                                                d="M2.101 11l.655-3.987L0 4.193l3.79-.584L5.512 0l1.723 3.644 3.79.584-2.757 2.819L8.923 11 5.512 9.11zM14.595 11l.655-3.987-2.756-2.82 3.79-.584L18.006 0l1.723 3.644 3.79.584-2.757 2.819.655 3.953-3.411-1.89zM27.09 11l.654-3.987-2.756-2.82 3.79-.584L30.5 0l1.723 3.644 3.789.584-2.756 2.819.655 3.953L30.5 9.11zM39.583 11l.655-3.987-2.756-2.82 3.79-.584L42.993 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89zM52.077 11l.655-3.987-2.756-2.82 3.79-.584L55.487 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89z">
                                            </path>
                                        </g>
                                    </svg>
                                    </span>
                                    <span class="acc__text">Average ratinging: `+recentlyviewedItemArray[i].rating+` out of 5</span>
                            </p>
                        </div>`;
                        if(this.ratingPercentage > 0){
                            this.productImagehrefTag.innerHTML += productRatingtemplate;
                        }
                    }

                }
            }
            this.totalslideRequired = (Math.ceil(slideliElements / 6));
            totalNumberofSlides = this.totalslideRequired;
            this.slidepageparentdiv = document.querySelector('.navfooter-desktopcarousel__bottomdiv');
            this.slideproductItem = document.querySelectorAll('.navfooter-desktopcarousel__slide-productitem');
            this.slideProductWrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
            this.carouselHeadingElement = document.querySelector('.navfooter-recentlyviewed__heading');
            this.bodyelement = document.querySelector('body');
            if (this.totalslideRequired > 1) {
                for (var btn = 1; btn <= this.totalslideRequired; btn++) {
                    this.slidepageparentdiv.innerHTML += sliderButtontemplate;
                    this.slidetext = this.slidepageparentdiv.querySelectorAll('.navfooter-desktopcarousel__slidenumber');
                    this.slideBtn = this.slidepageparentdiv.querySelectorAll('.navfooter-desktopcarousel__page-button');
                    this.slidetext[btn - 1].innerText = 'Slide ' + btn + ' ' + 'for recently viewed';
                    this.slideBtn[btn - 1].setAttribute('id', btn);
                }
                Utils.addClass(this.sliderpreviousbtn, 'activatenavigatebtn');
                Utils.addClass(this.slidernextbtn, 'activatenavigatebtn');
                this.sliderpreviousbtn.addEventListener('click', this.previousSlideEvent.bind(this));
                this.slidernextbtn.addEventListener('click', this.nextSlideEvent.bind(this));
                /* inline style width to Li */
                if ('1280' <= window.innerWidth && window.innerWidth < '1920') {
                    for (var j = 0; j < this.slideproductItem.length; j++) {
                        this.slideproductItem[j].style.width = (this.slideProductWrapper.offsetWidth - 112) / 6 + 'px';
                    }
                }
                this.slidepageparentdiv.addEventListener('click', this.slidebind.bind(this));
                this.activatebutton();
            }
            this.bindRemovefunction(recentlyviewedItemArray);
            if (window && (window.innerWidth >= '1280')) {
                this.bindswipefunction();
            }
            this.setCarouseIDfunction();
            this.carouselOnloadAnalytics();
            window.addEventListener('scroll', this.listenscrollEvent.bind(this));
        },

        bindRemovefunction: function (ele) {
            var removeElementTag = this.wrapper.querySelectorAll('.navfooter-desktopcarousel__remove');
            var undoWrapperTag = this.wrapper.querySelectorAll('.navfooter-desktopcarousel__undowrapper a');
            for (var fn = 0; fn < ele.length; fn++) {
                if (ele[fn].id !== '') {
                    removeElementTag[fn].addEventListener('click', this.removeProductHandler.bind(this));
                    undoWrapperTag[fn].addEventListener('click', this.undoProductHandler.bind(this));
                }
            }

        },
        slidebind: function (event) {

            if (Utils.hasClass(event.target, 'navfooter-desktopcarousel__page-button') && !(Utils.hasClass(event.target, 'activatebubblebtn'))) {
                setDirection = this.getDirection(event);
            }
            if (setDirection === 'fwd') {
                this.nextSlideEventbtnclick((event.target.getAttribute('id') - 1));
            }
            if (setDirection === 'bwd') {
                this.previousEventbtnclick((event.target.getAttribute('id') - 1));
            }
        },
        getDirection: function (event) {
            var navfooterslidepagebtn = document.querySelectorAll('.navfooter-desktopcarousel__page-button');
            for (var slidepagebtn = 0; slidepagebtn < navfooterslidepagebtn.length; slidepagebtn++) {
                if (navfooterslidepagebtn[slidepagebtn].classList.contains('activatebubblebtn')) {
                    if (slidepagebtn > (event.target.getAttribute('id') - 1)) {
                        setDirection = 'bwd'; //backward
                        activebubbleIndex = slidepagebtn;
                        return setDirection;
                    }
                    else if (slidepagebtn < (event.target.getAttribute('id') - 1)) {
                        setDirection = 'fwd'; //forward
                        activebubbleIndex = slidepagebtn;
                        return setDirection;
                    }
                }

            }
        },
        nextSlideEventbtnclick: function (elemCount) {
            var _this = this;
            elemCount ? _this.slideIndex = elemCount : false;
            _this.isLastSlide() ? _this.disablenextbtn() : _this.enablePreviousbtn();
            _this.slidercssfunction();
            _this.activatebutton(setDirection);
            if (this.totalslideRequired === 3) {
                if (elemCount === 1) {
                    leftSwipeCount++;
                    rightSwipeCount = (rightSwipeCount > 1) ? (rightSwipeCount - 1) : rightSwipeCount;
                }
                else if (elemCount === 2) {
                    leftSwipeCount = leftSwipeCount + 2;
                    rightSwipeCount = (rightSwipeCount > 1) ? (rightSwipeCount - 2) : rightSwipeCount;
                }
            }
            else {
                leftSwipeCount++;
                rightSwipeCount = (rightSwipeCount > 1) ? (rightSwipeCount - 1) : rightSwipeCount;
            }
            setTimeout(function () {
                if (_this.bodyelement.classList.contains('bodyoverflow')) {
                    _this.bodyelement.classList.remove('bodyoverflow');
                }
            }, 300);
        },
        previousEventbtnclick: function (elemCount) {
            var _this = this;
            if (elemCount >= 0) {
                _this.slideIndex = elemCount;
            }
            _this.isFirstSlide() ? _this.disablePreviousbtn() : _this.enablenextbtn();
            this.slidercssfunction();
            _this.activatebutton(setDirection);
            if (this.totalslideRequired === 3) {
                if (elemCount === 1) {
                    rightSwipeCount++;
                    leftSwipeCount = (leftSwipeCount > 1) ? (leftSwipeCount - 1) : leftSwipeCount;
                }
                else if (elemCount === 0) {
                    rightSwipeCount = rightSwipeCount + 2;
                    leftSwipeCount = (leftSwipeCount > 1) ? (leftSwipeCount - 2) : leftSwipeCount;
                }
            }
            else {
                rightSwipeCount++;
                leftSwipeCount = (leftSwipeCount > 1) ? (leftSwipeCount - 1) : leftSwipeCount;
            }


            setTimeout(function () {
                if (_this.bodyelement.classList.contains('bodyoverflow')) {
                    _this.bodyelement.classList.remove('bodyoverflow');
                }
            }, 300);
        },
        printwasprice: function (productwasPriceRangeDetails) {
            if (Config && Config.storeId === Constantvalues.ukId) {
                return productwasPriceRangeDetails[0] !== productwasPriceRangeDetails[1] ? Constantvalues.currencyUk + productwasPriceRangeDetails[0] + ' - ' + Constantvalues.currencyUk + productwasPriceRangeDetails[1] : Constantvalues.currencyUk + productwasPriceRangeDetails[0];
            }
            else if (Config && Config.storeId === Constantvalues.ieId) {
                return productwasPriceRangeDetails[0] !== productwasPriceRangeDetails[1] ? Constantvalues.currencyIe + productwasPriceRangeDetails[0] + ' - ' + Constantvalues.currencyIe + productwasPriceRangeDetails[1] : Constantvalues.currencyIe + productwasPriceRangeDetails[0];
            }
        },
        printPriceRange: function (productPriceRangeDetails) {
            if (Config && Config.storeId === Constantvalues.ukId) {
                if (productPriceRangeDetails[0] !== productPriceRangeDetails[1]) {
                    var productpriceinitial = productPriceRangeDetails[0].split('.');
                    var productpricefinal = productPriceRangeDetails[1].split('.');
                    if (productpriceinitial[1] === '00' && productpricefinal[1] === '00') {
                        return Constantvalues.currencyUk + productpriceinitial[0] + ' - ' + Constantvalues.currencyUk + productpricefinal[0];
                    }
                    else if (productpriceinitial[1] === '00' && productpricefinal[1] !== '00') {
                        return Constantvalues.currencyUk + productpriceinitial[0] + ' - ' + Constantvalues.currencyUk + productPriceRangeDetails[1];
                    }
                    else if (productpriceinitial[1] !== '00' && productpricefinal[1] === '00') {
                        return Constantvalues.currencyUk + productPriceRangeDetails[0] + ' - ' + Constantvalues.currencyUk + productpricefinal[0];
                    }
                    else {
                        return Constantvalues.currencyUk + productPriceRangeDetails[0] + ' - ' + Constantvalues.currencyUk + productPriceRangeDetails[1];
                    }
                } else {
                    var singleproductprice = productPriceRangeDetails[0].split('.');
                    if (singleproductprice[1] === '00') {
                        return Constantvalues.currencyUk + singleproductprice[0];
                    }
                    else {
                        return Constantvalues.currencyUk + productPriceRangeDetails[0];
                    }

                }
            }
            else if (Config && Config.storeId === Constantvalues.ieId) {
                return productPriceRangeDetails[0] !== productPriceRangeDetails[1] ? Constantvalues.currencyIe + productPriceRangeDetails[0] + ' - ' + Constantvalues.currencyIe + productPriceRangeDetails[1] : Constantvalues.currencyIe + productPriceRangeDetails[0];
            }
        },
        previousSlideEvent: function () {
            var _this = this;
            direction = 'Backward';
            _this.slideIndex -= 1;
            _this.isFirstSlide() ? _this.disablePreviousbtn() : _this.enablenextbtn();
            this.slidercssfunction();
            this.activatebutton(direction);
            rightSwipeCount++;
            leftSwipeCount = (leftSwipeCount > 1) ? (leftSwipeCount - 1) : leftSwipeCount;
            setTimeout(function () {
                if (_this.bodyelement.classList.contains('bodyoverflow')) {
                    _this.bodyelement.classList.remove('bodyoverflow');
                }
            }, 300);
        },
        nextSlideEvent: function () {
            var _this = this;
            direction = 'Forward';
            _this.slideIndex += 1;
            _this.isLastSlide() ? _this.disablenextbtn() : _this.enablePreviousbtn();
            this.slidercssfunction();
            this.activatebutton(direction);
            this.scrollrightclickAnalytics();
            leftSwipeCount++;
            rightSwipeCount = (rightSwipeCount > 1) ? (rightSwipeCount - 1) : rightSwipeCount;
            setTimeout(function () {
                if (_this.bodyelement.classList.contains('bodyoverflow')) {
                    _this.bodyelement.classList.remove('bodyoverflow');
                }
            }, 300);
        },
        activatebutton: function (direction) {
            var btnlist = document.querySelectorAll('.navfooter-desktopcarousel__page-button');
            Utils.addClass(btnlist[this.slideIndex], 'activatebubblebtn');
            if (direction === 'Forward') {
                Utils.hasClass(btnlist[this.slideIndex - 1], 'activatebubblebtn') ? Utils.removeClass(btnlist[this.slideIndex - 1], 'activatebubblebtn') : false;
                direction = '';
            }
            else if (direction === 'Backward') {
                Utils.hasClass(btnlist[this.slideIndex + 1], 'activatebubblebtn') ? Utils.removeClass(btnlist[this.slideIndex + 1], 'activatebubblebtn') : false;
                direction = '';
            }
            if (setDirection === 'fwd' && (activebubbleIndex >= 0)) {
                Utils.hasClass(btnlist[activebubbleIndex], 'activatebubblebtn') ? Utils.removeClass(btnlist[activebubbleIndex], 'activatebubblebtn') : false;
                setDirection = '';
            }
            else if (setDirection === 'bwd' && (activebubbleIndex >= 0)) {
                Utils.hasClass(btnlist[activebubbleIndex], 'activatebubblebtn') ? Utils.removeClass(btnlist[activebubbleIndex], 'activatebubblebtn') : false;
                setDirection = '';
            }

        },
        isLastSlide: function () {
            if (this.slideIndex === (this.totalslideRequired - 1)) {
                return true;
            }
            else {
                return false;
            }
        },
        isFirstSlide: function () {
            if (this.slideIndex === 0) {
                return true;
            }
            else {
                return false;
            }
        },
        disablePreviousbtn: function () {
            this.sliderpreviousbtn.setAttribute('aria-disabled', 'true');
            this.sliderpreviousbtn.setAttribute('disabled', 'true');
            this.slidernextbtn.getAttribute('aria-disabled') ? this.slidernextbtn.setAttribute('aria-disabled', 'false') : false;
            this.slidernextbtn.getAttribute('disabled') ? this.slidernextbtn.removeAttribute('disabled') : false;
        },
        enablenextbtn: function () {
            this.slidernextbtn.setAttribute('aria-disabled', 'false');
            this.slidernextbtn.getAttribute('disabled') ? this.slidernextbtn.removeAttribute('disabled') : false;
        },
        disablenextbtn: function () {
            this.slidernextbtn.setAttribute('aria-disabled', 'true');
            this.slidernextbtn.setAttribute('disabled', 'true');
            this.sliderpreviousbtn.getAttribute('aria-disabled') ? this.sliderpreviousbtn.setAttribute('aria-disabled', 'false') : false;
            this.sliderpreviousbtn.getAttribute('disabled') ? this.sliderpreviousbtn.removeAttribute('disabled') : false;
        },
        enablePreviousbtn: function () {
            this.sliderpreviousbtn.setAttribute('aria-disabled', 'false');
            this.sliderpreviousbtn.getAttribute('disabled') ? this.sliderpreviousbtn.removeAttribute('disabled') : false;
        },
        slidercssfunction: function () {
            if ('1280' <= window.innerWidth && window.innerWidth < '1920') {
                position = this.slideIndex * (this.slideProductWrapper.offsetWidth - 16);
                positionValue = 'translateX(-' + position + 'px)';
                this.slideProductWrapper.style.transform = positionValue;
            }
            else if (window.innerWidth >= '1920') {
                position = this.slideIndex * this.slideProductWrapper.offsetWidth;
                positionValue = 'translateX(-' + position + 'px)';
                this.slideProductWrapper.style.transform = positionValue;
            }
        },
        undoProductHandler: function (event) {
            event.preventDefault();
            var element = event.currentTarget;
            var parentElement = element.parentNode;
            var grandParentElement = parentElement.parentNode.parentNode;
            var productId = grandParentElement.getAttribute('id');
            productTcode = grandParentElement.getAttribute('tcode');
            productcarouselinteractionId = grandParentElement.getAttribute('carouselinteractionid');
            clearTimeout(timeoutForRemoveProduct[productId]);
            parentElement.style.display = 'none';
            parentElement.previousElementSibling.style.display = 'block';
            setTimeout(function () {
                parentElement.previousElementSibling.style.opacity = '1';
            }, 10);
            grandParentElement.style.display = 'block';
            this.undoanalyticsfunction(productTcode, productcarouselinteractionId);
        },

        removeProductHandler: function (event) {
            var _this = this;
            event.preventDefault();
            var parentElement = event.currentTarget.parentNode;
            var grandParentElement = parentElement.parentNode.parentNode;
            var productId = grandParentElement.getAttribute('id');
            productTcode = grandParentElement.getAttribute('tcode');
            productcarouselinteractionId = grandParentElement.getAttribute('carouselinteractionid');
            parentElement.style.opacity = '0';
            setTimeout(function () {
                styleUndoWrpperElm(parentElement, grandParentElement);
                timeoutForRemoveProduct[productId] = setTimeout(function () {
                    if (window.outerWidth >= 1280) {
                        grandParentElement.style.width = '0' + 'px';
                        grandParentElement.style.margin = '0' + 'px';
                    }
                    else {
                        grandParentElement.style.flexBasis = '0' + 'px';
                        grandParentElement.style.width = '0' + 'px';
                        grandParentElement.style.margin = '0' + 'px';
                    }
                    grandParentElement.querySelector('.navfooter-desktopcarousel__undowrapper').style.opacity = '0';
                    _this.removeProductFromDom(productId, grandParentElement, productTcode, productcarouselinteractionId);
                }, 4000);
            }, 500);
            function styleUndoWrpperElm(parentElement, grandParentElement) {
                var undoWrapperElm = grandParentElement.querySelector('.navfooter-desktopcarousel__undowrapper');
                var topStyle = (parentElement.clientHeight / 2) + 'px';
                undoWrapperElm.style.opacity = '1';
                undoWrapperElm.style.display = 'flex';
                var marginLeftStyle = ((parentElement.clientWidth - undoWrapperElm.clientWidth) / 2) + 'px';
                undoWrapperElm.style.top = topStyle;
                undoWrapperElm.style.marginLeft = marginLeftStyle;
            }
        },
        removeProductFromDom: function (productId, grandParentElement, productTcode, productcarouselinteractionId) {
            var _this = this;
            var bubblebtnhtml = document.querySelectorAll('.navfooter-desktopcarousel__page-button');
            setTimeout(function () {
                var item = document.getElementById(productId);
                grandParentElement.parentNode.removeChild(item);
                removedItemCount++;
                var CurrentNumberOfSlides = (Math.ceil((slideliElements - removedItemCount) / 6));
                _this.totalslideRequired = CurrentNumberOfSlides;
                if ((totalNumberofSlides - CurrentNumberOfSlides) !== 0) {
                    bubblebtnhtml[CurrentNumberOfSlides] ? bubblebtnhtml[CurrentNumberOfSlides].remove() : false;
                    totalNumberofSlides -= 1;
                }
                _this.isLastSlide() ? _this.disablenextbtn() : false;
                if (CurrentNumberOfSlides === _this.slideIndex) {
                    _this.slideIndex--;
                    _this.slidercssfunction();
                    bubblebtnhtml[CurrentNumberOfSlides] ? bubblebtnhtml[CurrentNumberOfSlides].remove() : false;
                    bubblebtnhtml[CurrentNumberOfSlides - 1] ? Utils.addClass(bubblebtnhtml[CurrentNumberOfSlides - 1], 'activatebubblebtn') : false;
                    if (_this.isFirstSlide()) {
                        bubblebtnhtml[CurrentNumberOfSlides - 1].remove();
                        _this.sliderpreviousbtn.style.display = 'none';
                        _this.slidernextbtn.style.display = 'none';
                    }
                }
                if (_this.slideIndex === 0 && CurrentNumberOfSlides === 1) {
                    _this.sliderpreviousbtn.style.display = 'none';
                    _this.slidernextbtn.style.display = 'none';
                    if (bubblebtnhtml[CurrentNumberOfSlides - 1]) {
                        bubblebtnhtml[CurrentNumberOfSlides - 1].remove();
                    }
                }

                if (CurrentNumberOfSlides === 0) {
                    document.querySelector('.navfooter-recentlyviewContainer').style.display = 'none';
                }
                _this.removeProductFromAdobe(productId);
                _this.removeanalyticsfunction(productTcode, productcarouselinteractionId);
            }, 1000);
        },
        removeProductFromAdobe: function (productId) {
            var _this = this;
            var targetResponseTokens = {};
            var pid; //eslint-disable-line no-unused-vars
            if (window.targetResponseTokens && window.targetResponseTokens.length > 0) {
                _this.removingProductIdFromParams(productId, targetResponseTokens);
                window.adobe.target.getOffer({
                    'mbox': 'target-global-mbox', 'params': targetResponseTokens,
                    'success': function (offer) {
                        pid = productId;   //eslint-disable-line no-unused-vars
                        window.adobe.target.applyOffer({ 'mbox': 'target-global-mbox', 'offer': offer });
                    },
                    'error': function (status, error) {
                        console.log('Error', status, error); // eslint-disable-line no-console
                    }
                });
            }
        },
        removingProductIdFromParams: function (productId, targetResponseTokens) {
            var count = 1;
            var _this = this;
            var excludedProducts = window.targetResponseTokens[0][`profile.excludedProducts${count}`];
            var products = excludedProducts && excludedProducts !== '' && excludedProducts !== 'null' ? JSON.parse(excludedProducts) : [];
            if (products.length > 15 && count < 5) {
                targetResponseTokens[`profile.excludedProducts${count}`] = JSON.stringify(products);
                count++;
                return _this.removingProductIdFromParams(productId, targetResponseTokens, count);
            } else {
                if (products.length <= 15) {
                    products.push(productId);
                }
            }
            targetResponseTokens[`profile.excludedProducts${count}`] = JSON.stringify(products);
            return targetResponseTokens;
        },
        removeanalyticsfunction: function (productTcode, productcarouselinteractionId) {
            var carousel_interaction_id = productcarouselinteractionId; // eslint-disable-line camelcase
            if (typeof utag !== 'undefined' && typeof utag.link === 'function') { // eslint-disable-line no-undef, camelcase
                utag.link({ link_name: 'carousel:remove item', carousel_interaction_id: carousel_interaction_id, product_stroke: [productTcode], event_name: 'carousel_item_remove' }); // eslint-disable-line no-undef, camelcase
            }
        },
        undoanalyticsfunction: function (productTcode, productcarouselinteractionId) {
            if (typeof utag !== 'undefined' && typeof utag.link === 'function') { // eslint-disable-line no-undef, camelcase
                utag.link({ link_name: 'carousel:undo remove item', carousel_interaction_id: productcarouselinteractionId, product_stroke: [productTcode], event_name: 'carousel_undo_item_remove' }); // eslint-disable-line no-undef, camelcase
            }
        },
        scrollrightclickAnalytics: function () {
            if (scrollclicked === 0) {
                if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) { // eslint-disable-line no-undef, camelcase
                    utag.link({ link_name: 'carousel:scroll click', event_name: 'carousel_scroll', carousel_id: window.setCarouselIdforAnalytics }); // eslint-disable-line no-undef, camelcase
                }
                scrollclicked++;
            }

        },
        setCarouseIDfunction: function () {
            var listofItem = document.querySelectorAll('.navfooter-desktopcarousel__slide-product');
            var setCarouselIdforAnalytics;
            for (var eachlistofItem = 0; eachlistofItem < listofItem.length; eachlistofItem++) {
                if (eachlistofItem === (listofItem.length - 1)) {
                    setCarouselIdforAnalytics = listofItem[eachlistofItem].getAttribute('carouselinteractionid');
                    window.setCarouselIdforAnalytics = setCarouselIdforAnalytics;
                }
            }
        },
        carouselOnloadAnalytics: function () {
            if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) { // eslint-disable-line no-undef, camelcase
                utag.link({ carousel_id: window.setCarouselIdforAnalytics, link_name: 'carousel:present', event_name: 'carousel_present' }); // eslint-disable-line no-undef, camelcase
            }
        },
        listenscrollEvent: function () {
            if (carouselseenCount === 0) {
                var callseenfunction = this.isCarouselSeen(this.carouselHeadingElement);
                if (callseenfunction) {
                    this.callcarouselseenAnalytics();
                    carouselseenCount++;
                }
            }
        },
        isCarouselSeen: function (el) {
            if (el) {
                var rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        },
        callcarouselseenAnalytics: function () {
            if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) { // eslint-disable-line no-undef, camelcase
                utag.link({ carousel_id: window.setCarouselIdforAnalytics, event_name: 'carousel_seen', link_name: 'carousel:seen' }); // eslint-disable-line no-undef, camelcase
            }
        },
        swipeLeftAnalyticsfunction: function () {
            if (leftswiped === 0) {
                if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) { // eslint-disable-line no-undef, camelcase
                    utag.link({ link_name: 'carousel:scroll swipe', event_name: 'carousel_scroll', carousel_id: window.setCarouselIdforAnalytics }); // eslint-disable-line no-undef, camelcase
                }
                leftswiped++;
            }
        },
        bindswipefunction: function () {
            var carouselProductWrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
            carouselProductWrapper.addEventListener('touchstart', this.handleTouchStart.bind(this), false);
            carouselProductWrapper.addEventListener('touchmove', this.handleTouchMove.bind(this), false);
        },
        getTouches: function (evt) {
            return evt.touches ||
                evt.originalEvent.touches;
        },
        handleTouchStart: function (evt) {
            var firstTouch = this.getTouches(evt)[0];
            xDown = firstTouch.clientX;
            yDown = firstTouch.clientY;
        },
        handleTouchMove: function (evt) {
            if (!xDown || !yDown) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                if (xDiff > 0) {
                    /* left swipe */
                    evt.preventDefault();
                    evt.stopPropagation();
                    if ((leftSwipeCount < this.totalslideRequired) && !this.isLastSlide()) {
                        Utils.addClass(this.bodyelement, 'bodyoverflow');
                        this.nextSlideEvent();
                        this.swipeLeftAnalyticsfunction();
                    }
                } else {
                    /* right swipe */
                    evt.preventDefault();
                    evt.stopPropagation();
                    if ((rightSwipeCount < this.totalslideRequired) && !this.isFirstSlide()) {
                        Utils.addClass(this.bodyelement, 'bodyoverflow');
                        this.previousSlideEvent();
                    }
                }
            }
            xDown = null;
            yDown = null;
        }


    };
    return Carouseltemplate;
});



/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/carouseltemplate.js
 **/